import './assets/main.css'
import { createApp } from 'vue'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { createPinia } from 'pinia'
import { KtPlugin } from 'metronics-vue'
import App from './App.vue'
import router from './router'
import ApexCharts from "apexcharts";
import ApexChart from "vue3-apexcharts";
import { Cache } from './services/cache'

const app = createApp(App)

function isInIFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true; // If an error occurs, assume we are in an iframe
    }
}
app.use(Vue3Toastify, {
    autoClose: 3000,
    position: 'top-right',
    
});
app.use(router)
app.use(KtPlugin)
app.use(createPinia())
app.component("apexchart", ApexChart);
app.use(ApexChart);
app.config.globalProperties.$apexcharts = ApexCharts


if(isInIFrame()) {
    window.addEventListener('message', event => {
        if (event.data.token) {
            Cache.set('token', event.data.token)
            app.mount('#app')
        }
    })
} else {
    app.mount('#app')
}